export default function CookieSettingsButton() {

  const openManager = () => {
    window.dispatchEvent(new Event("openCookieManager"));
  };

  return (
    <button
      onClick={openManager}
      className="fixed bottom-4 left-4 text-sm underline text-brand-sage bg-brand-dark px-3 py-2 rounded shadow hover:bg-brand-sage/10 focus:outline-none focus:ring-2 focus:ring-brand-sage"
    >
      Configurar Cookies
    </button>
  );
}